import { ChangeEvent } from 'react';
import AccordionComponent from '../common/Accordion';
import RadioGroupComponent from '../common/RadioGroup';
import styles from './styles';

export interface IAdminFilterModalProps {
    selectedStatus?: string | number | boolean;
    selectedRole?: string | number | boolean;
    selectedPeriod?: string | number | boolean;
    onStatusChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    onRoleChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    onPeriodChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    roles?: Array<{ id: number; role: string }>;
}
const statusData = [
    {
        value: 'active',
        label: 'Active',
    },
    {
        value: 'inActive',
        label: 'Inactive',
    },
];
const additionPeriodData = [
    {
        value: 'LastWeek',
        label: 'Last Week',
    },
    {
        value: 'Last14Days',
        label: 'Last 14 Days',
    },
    {
        value: 'LastMonth',
        label: 'Last Month',
    },
    {
        value: 'LastQuarter',
        label: 'Last Quarter',
    },
];
const AdminFilterModal = ({
    selectedStatus,
    selectedRole,
    selectedPeriod,
    onStatusChange,
    onRoleChange,
    onPeriodChange,
    roles,
}: IAdminFilterModalProps) => {
    return (
        <>
            <AccordionComponent
                data={[
                    {
                        summary: 'Status',
                        detailsNode: (
                            <RadioGroupComponent
                                classes={styles.radioGroupLabel}
                                data={statusData}
                                selectedValue={selectedStatus}
                                name="status"
                                onChange={onStatusChange}
                            />
                        ),
                    },
                    {
                        summary: 'Role',
                        detailsNode: (
                            <RadioGroupComponent
                                classes={styles.radioGroupLabel}
                                data={(roles ?? []).map((x) => ({ value: x.id, label: x.role }))}
                                selectedValue={selectedRole}
                                name="role"
                                onChange={onRoleChange}
                            />
                        ),
                    },
                    {
                        summary: 'Addition Period',
                        detailsNode: (
                            <RadioGroupComponent
                                classes={styles.radioGroupLabel}
                                data={additionPeriodData}
                                selectedValue={selectedPeriod}
                                name="additional-period"
                                onChange={onPeriodChange}
                            />
                        ),
                    },
                ]}
            />
        </>
    );
};
export default AdminFilterModal;
